/* eslint-disable no-param-reassign */
// eslint-disable-next-line no-unused-vars
import { FETCH_FOLDERS_SUCCESS, UPDATE_APP_DATA } from 'constants/action_types'
import { createActionTypeReducer } from 'util/reducers'

const byIdInitialState = {
  fol_0: {
    id: 'fol_0',
    name: 'Unassigned',
    position: 1,
    conditions: [],
    displayCountWhenInactive: true,
    matchType: 'all',
    queryId: 'folder:fol_0',
  },
  fol_1: {
    id: 'fol_1',
    name: 'Mine',
    position: 2,
    conditions: [],
    displayCountWhenInactive: true,
    matchType: 'all',
    queryId: 'folder:fol_1',
  },
  fol_2: {
    id: 'fol_2',
    name: 'Open',
    position: 3,
    conditions: [],
    displayCountWhenInactive: true,
    matchType: 'all',
    queryId: 'folder:fol_2',
  },
  fol_3: {
    id: 'fol_3',
    name: 'Snoozed',
    position: 4,
    conditions: [],
    displayCountWhenInactive: true,
    matchType: 'all',
    queryId: 'folder:fol_3',
  },
  fol_4: {
    id: 'fol_4',
    name: 'Closed',
    position: 6,
    conditions: [],
    displayCountWhenInactive: false,
    matchType: 'all',
    queryId: 'folder:fol_4',
  },
  fol_5: {
    id: 'fol_5',
    name: 'Trash',
    position: 7,
    conditions: [],
    displayCountWhenInactive: false,
    matchType: 'all',
    queryId: 'folder:fol_5',
  },
  fol_6: {
    id: 'fol_6',
    name: 'Spam',
    position: 8,
    conditions: [],
    displayCountWhenInactive: false,
    matchType: 'all',
    queryId: 'folder:fol_6',
  },
}

// eslint-disable-next-line no-unused-vars
function byIdFetchFolderSuccessReducer(draftState, { data: { folders = [] } }) {
  folders.forEach((folder, index) => {
    const { id } = folder
    const position = index + 1
    const folderId = `fol_${id}`
    draftState[folderId] = {
      ...folder,
      id: folderId,
      position,
      queryId: `folder:${folderId}`,
    }
  })
  return draftState
}

export const byId = createActionTypeReducer(
  {
    // We've leave these disabled for now and use the hard coded folders
    // until we've extended the backend of the chat system to also support
    // our complete folder and rule sets
    // [FETCH_FOLDERS_SUCCESS]: byIdFetchFolderSuccessReducer,
    // [UPDATE_APP_DATA]: byIdFetchFolderSuccessReducer,
  },
  byIdInitialState
)
